// extracted by mini-css-extract-plugin
export var chevron = "_g8-2";
export var chevronRotated = "_g8-3";
export var header = "_g8-1";
export var section = "_g8-0";